import { render, staticRenderFns } from "./DepartamentoSguList.vue?vue&type=template&id=2e457fce"
import script from "./DepartamentoSguList.vue?vue&type=script&lang=js"
export * from "./DepartamentoSguList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports